import React, { useState } from "react";
import sca_logo from "../images/sca_logo.jpeg";
import emailIcon from "../images/email.png";

const Person = ({ person, PortraitPhoto }) => {
  const [showEmail, setShowEmail] = useState(false);
  const [copied, setCopied] = useState(false);

  const employeeName = `${person.First_Name ?? ""} ${person.Last_Name ?? ""}`.trim();

  const location =
    person.Mailing_City && person.Mailing_State_Province
      ? `${person.Mailing_City}, ${person.Mailing_State_Province}`
      : person.Mailing_State_Province || person.Mailing_City || "";

  const imgSrc = person.Headshot_URL || sca_logo;

  const handleImgError = (e) => {
    if (e.currentTarget.src !== sca_logo) {
      e.currentTarget.src = sca_logo;
    }
  };

  const rawEmail = typeof person.Email === "string" ? person.Email.trim() : "";
  const email =
    rawEmail &&
    rawEmail.toLowerCase() !== "null" &&
    rawEmail.toLowerCase() !== "undefined"
      ? rawEmail
      : "";

  const hasEmail = email.length > 0;

  const mailtoLink = hasEmail
    ? `mailto:${email}?subject=${encodeURIComponent(`Hello ${person.First_Name || ""}`)}`
    : "";

  const handleEmailClick = (e) => {
    e.preventDefault();

    if (!hasEmail) return;

    setShowEmail(true);
    setCopied(false);

    /*
      This opens the user's default mail app if one is configured.
      We intentionally do NOT use target="_blank" because that can cause
      blank Edge/Chrome windows on some computers.
    */
    window.location.href = mailtoLink;
  };

  const handleCopyEmail = async () => {
    if (!hasEmail) return;

    try {
      await navigator.clipboard.writeText(email);
      setCopied(true);

      window.setTimeout(() => {
        setCopied(false);
      }, 2000);
    } catch {
      setCopied(false);
    }
  };

  return (
    <div className="bg-white rounded-xl shadow-md h-full">
      <div className="p-4 h-full flex flex-col">
        <PortraitPhoto
          src={imgSrc}
          alt={employeeName ? `Headshot of ${employeeName}` : "Headshot"}
          onError={handleImgError}
        />

        <div className="mt-4 flex flex-col flex-1">
          <h2 className="text-xl font-bold">
            {employeeName || "Unnamed Employee"}
          </h2>

          {person.Title !== "Intern" ? (
            <h3 className="text-gray-600 mt-2">
              At Sand Cherry since {person.Start_Year}
            </h3>
          ) : (
            <h3 className="text-gray-600 mt-2">Intern</h3>
          )}

          <h3 className="text-gray-600 mt-2">
            Focus: {person.Focus || ""}
          </h3>

          {location && (
            <h3 className="text-gray-600 mt-2">
              Home Base: {location}
            </h3>
          )}

          {hasEmail && (
            <div className="mt-3 flex flex-col items-center">
              <button
                type="button"
                onClick={handleEmailClick}
                aria-label={`Email ${employeeName || "this employee"}`}
                title={`Email ${employeeName || "this employee"}`}
                className="inline-flex items-center justify-center rounded-full p-2 hover:bg-gray-100 transition"
              >
                <img
                  src={emailIcon}
                  alt="Email"
                  className="w-5 h-5 object-contain"
                />
              </button>

              {showEmail && (
                <div className="mt-2 w-full rounded-lg border border-gray-200 bg-gray-50 px-3 py-2 text-center">
                  <a
                    href={mailtoLink}
                    className="text-sm text-sky-900 underline break-all"
                  >
                    {email}
                  </a>

                  <button
                    type="button"
                    onClick={handleCopyEmail}
                    className="mt-2 block w-full rounded-md bg-sky-950 hover:bg-sky-700 text-white text-xs font-semibold py-1.5 transition"
                  >
                    {copied ? "Copied" : "Copy Email"}
                  </button>
                </div>
              )}
            </div>
          )}

          <div className="mt-auto" />
        </div>
      </div>
    </div>
  );
};

export default Person;